const ROOT = 'TALENT_ENABLE_SKILL_MODAL_';

const actions = {
  PROCESS_ACTION_REQUEST: `${ROOT}PROCESS_ACTION_REQUEST`,
  PROCESS_ACTION_SUCCESS: `${ROOT}PROCESS_ACTION_SUCCESS`,
  PROCESS_ACTION_ERROR: `${ROOT}PROCESS_ACTION_ERROR`,
  LOAD_FORM_INFO_SUCCESS: `${ROOT}LOAD_FORM_INFO_SUCCESS`,
  CHANGE_PROPERTY: `${ROOT}CHANGE_PROPERTY`,
  CHANGE_MODAL_VISIBILITY: `${ROOT}CHANGE_MODAL_VISIBILITY`,
  CLEAR_STATE: `${ROOT}CLEAR_STATE`,
} as const;

export default actions;
